import {createFileRoute} from '@tanstack/react-router'
import {type} from 'arktype'

import guestRoute from '@/auth/middleware/guestRoute'
import searchParamString from '@/utils/schema/searchParamString'

const signInSearchSchema = type({
  redirect: searchParamString.optional(),
})

export const Route = createFileRoute('/auth/sign-in')({
  validateSearch: signInSearchSchema,
  beforeLoad: ({context, search}) => {
    guestRoute(context.store, search.redirect)
  },
})
